module.exports = __webpack_public_path__ + "img/ojfeature2.32e723f5.jpg";